import { useQuery } from 'react-query';

import { JobServiceType, JsonDataItem, PaymentMethod, ServiceType } from 'types';
import { parseErrors, Toast } from 'helpers';
import { getPaymentInfo, getPaymentMethods } from 'queries';

export const usePaymentMethod = (
  customerId: number | undefined,
  jobServiceType: JobServiceType,
  serviceType: ServiceType,
) => {
  const { data: paymentInfo, isLoading: isInfoLoading } = useQuery(['payment-info', customerId], getPaymentInfo, {
    enabled: !!customerId,
    onError: (error: JsonDataItem) => {
      Toast.show({ description: parseErrors(error).join(', '), type: Toast.Type.Error });
    },
  });

  const { data: availablePaymentMethods, isLoading: isMethodsLoading } = useQuery(
    [
      'payment-methods',
      {
        serviceType,
        jobServiceType,
        customerId,
      },
    ],
    getPaymentMethods,
    {
      enabled: Boolean(jobServiceType),
      onError: (error: JsonDataItem) => {
        Toast.show({ description: parseErrors(error).join(', '), type: Toast.Type.Error });
      },
    },
  );

  const getDefaultPaymentMethod = () => {
    switch (true) {
      case !!paymentInfo?.prepaid:
        return PaymentMethod.Prepaid;

      case !!paymentInfo?.is_geek_cover:
        return PaymentMethod.GeekCover;

      case jobServiceType === JobServiceType.WarrantyAssessment:
        return PaymentMethod.WarrantyAssessment;

      case !!paymentInfo?.invoiced:
        return PaymentMethod.Invoice;

      case !!paymentInfo?.ow30dba:
        return PaymentMethod.OW30DBA;

      default:
        return PaymentMethod.CreditCard;
    }
  };

  const defaultPaymentMethod = getDefaultPaymentMethod();
  const cardDetails = paymentInfo?.card_details || {};
  const isPaymentInfoLoading = isInfoLoading || isMethodsLoading;

  return { defaultPaymentMethod, availablePaymentMethods, isPaymentInfoLoading, paymentInfo, cardDetails };
};
